import { CurrencyFormat } from '@lt/components';
import React from 'react';
import styled, { css } from 'styled-components';
import { capitalize } from 'lodash';
import type { PriceDetailType } from '../../../../types';

import { getPrefix } from './utils';

type Props = {
  testId: string;
} & PriceDetailType;

const PriceDetail = ({ description, price, type, testId }: Props) => {
  const prefix = getPrefix(type);

  const formattedDescription = capitalize(description);

  return (
    <Wrapper data-testid={testId}>
      <Description $type={type}>{formattedDescription}</Description>
      <Price $type={type}>
        {prefix}
        <CurrencyFormat value={price} />
      </Price>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const Description = styled.div<{ $type: PriceDetailType['type'] }>`
  ${(props) =>
    props.$type !== 'basic' &&
    css`
      color: #4d4d4d;
    `}
`;

const Price = styled.div<{ $type: PriceDetailType['type'] }>`
  padding: 2px 6px;
  border-radius: 10px;

  ${(props) =>
    props.$type === 'cashback' &&
    css`
      color: #5d6fb4;
    `}
`;

export default PriceDetail;
